module.exports = __webpack_public_path__ + "static/media/icono (4).fcdd0139.svg";